import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { __ } from "@/i18n";
import { LANGUAGES } from "@/languages/language";
import { useWidgetStore } from "@/stores/widget-store";

export function LanguageSelector() {
  const setLanguage = useWidgetStore((state) => state.setLanguage);
  const defaultLanguage = useWidgetStore((state) => state.config.language.default);
  
  const handleLanguageChange = (language: string) => {
    setLanguage(language);     
  };
  
  return (
    <Select value={defaultLanguage} onValueChange={handleLanguageChange}>
      <SelectTrigger className="cy:w-[296px] cy:rounded cy:py-5.5 cy:shadow-none cy:text-base!">
        <SelectValue placeholder={__( 'Select Language', 'accessibility-widget' )} />
      </SelectTrigger>

      <SelectContent className="cy:text-base!">
        <SelectGroup>
          <SelectLabel>{__( 'Languages', 'accessibility-widget' )}</SelectLabel>
          {LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code} className="cy:text-base!">
              {lang.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
